import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.9984 0.999023L13.0002 3.17032C14.1658 3.58196 15.0009 4.69339 15.0009 5.99987C15.0009 7.30608 14.1661 8.41732 13.0009 8.82916V13.1259C14.7261 13.5699 16.0009 15.136 16.0009 16.9999C16.0009 17.9861 15.6427 18.8913 15.0505 19.5884C14.9896 19.6601 14.9262 19.7296 14.8605 19.7968L16.7535 22.9999H14.4286L13.1489 20.8324C12.7848 20.9414 12.3993 20.9999 12.0009 20.9999C11.602 20.9999 11.2159 20.9412 10.8513 20.8319L9.57374 22.9999H7.25L9.14014 19.7956C9.09444 19.7488 9.04989 19.701 9.00652 19.652C8.34657 18.9073 8.0009 18.0088 8.0009 16.9999C8.0009 15.136 9.27567 13.5699 11.0009 13.1259V8.82916C9.83571 8.41732 9.0009 7.30608 9.0009 5.99987C9.0009 4.69391 9.83537 3.58285 11.0002 3.17082L10.9984 1.00071L12.9984 0.999023Z"}}]};

const PearlOfTheOrientFilled = Vue.extend<IconProps>({
  name: 'PearlOfTheOrientFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pearl-of-the-orient-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PearlOfTheOrientFilled;
